import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { tracksWidth, arrowWidth } from "../../config/defaults";
import { TRACK_DIFFICULTY_BLUE } from "../../config/constants";

const Connector8CRed8DBlue = ({ state, workState }) => (
	<g id="Track-8D-blue-connector" transform="translate(1904.000000, 611.000000)">
		<g id="line" transform="translate(0.000000, 0.609312)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			 strokeLinecap="round"
		>
			<path
				strokeWidth={tracksWidth}
				d="M146,127.890688 L204.243283,161.107561 C208.004583,163.252677 211.083958,166.415978 213.127184,170.233585 L229,199.890688 L229,199.890688"/>
		</g>
	</g>
);

export default Connector8CRed8DBlue;
